module.exports = __webpack_public_path__ + "img/doc.f6984c55.png";